import React, { useContext, useState } from "react";
import { AppContextType, WonmovContext } from "@/context/app-context";
import { useHistory } from "react-router-dom";
import { userRepo } from "@/repo/user-repo";
import TextField from "@/component/widgets/text-field";
import SelectField from "@/component/widgets/select-field";
import TextareaField from "@/component/widgets/textarea-field";

export default function CreateListPage() {
    var setNotification = useContext<AppContextType>(WonmovContext).setNotification;
    var isLoadingState = useState(false);
    var isLoading = isLoadingState[0];
    var setIsLoading = isLoadingState[1];
    var nameState = useState("");
    var name = nameState[0];
    var setName = nameState[1];
    var descriptionState = useState("");
    var description = descriptionState[0];
    var setDescription = descriptionState[1];
    var typeState = useState<"public" | "private" | undefined>(undefined);
    var type = typeState[0];
    var setType = typeState[1];
    var history = useHistory();

    var handleSubmit = function () {
        if (isLoading) {
            return;
        }
        if (!name) {
            setNotification({ type: "danger", message: "نام لیست را وارد کنید" });
            return;
        }
        if (!description) {
            setNotification({ type: "danger", message: "توضیحات لیست را وارد کنید" });
            return;
        }
        if (!type) {
            setNotification({ type: "danger", message: "نوع لیست را انتخاب کنید" });
            return;
        }
        setIsLoading(true);
        userRepo.createList(name, description, type === "public").then(function (res) {
            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                setIsLoading(false);
                return;
            }
            setNotification({ type: "success", message: "لیست با موفقیت ایجاد شد" });
            setIsLoading(false);
            history.replace("/profile/lists/" + (res.data ? res.data.id : ""));
        });
    };

    return (
        <div className="profile-panel profile-lists-form">
            <h2 className="profile-panel__title">ایجاد لیست جدید</h2>

            <div className="profile-edit__form">
                <div className="profile-edit__field">
                    <TextField
                        name="name"
                        value={name}
                        placeholder="نام لیست"
                        onChange={function (e) {
                            setName(e.target.value);
                        }}
                    />
                </div>
                <div className="profile-edit__field">
                    <SelectField
                        uniqueKey="type"
                        value={type || ""}
                        options={[
                            { label: "انتخاب نوع", value: "" },
                            { label: "عمومی", value: "public" },
                            { label: "خصوصی", value: "private" },
                        ]}
                        onChange={function (value) {
                            setType(value as "public" | "private");
                        }}
                    />
                </div>
                <div className="profile-edit__field profile-edit__field--full">
                    <TextareaField
                        name="description"
                        value={description}
                        placeholder="توضیحات لیست"
                        onChange={function (e) {
                            setDescription(e.target.value);
                        }}
                    />
                </div>
                <div className="profile-edit__actions">
                    <button
                        type="button"
                        className="profile-edit__submit"
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? <div className="loader"></div> : "ایجاد لیست"}
                    </button>
                </div>
            </div>
        </div>
    );
}
